import { ErrorHandler, Injectable, Injector } from "@angular/core";

import { DffError, getErrorMessage } from "@dffedb/util";

import { LogService } from "../log/log.service";

const MATOMO_NOISE = [/setSiteId is registered more than once/i, /setTrackerUrl is registered more than once/i, /error setting cookie\s+`?_pk_/i];

@Injectable()
export class EforsyningErrorHandler implements ErrorHandler {
    constructor(private injector: Injector) {}

    public handleError(error: any): void {
        const unwrapped = error?.rejection || error;

        if (unwrapped instanceof DffError && unwrapped.suppressLog) {
            return;
        }

        const message = String(getErrorMessage(unwrapped) ?? "");
        if (MATOMO_NOISE.some((pattern) => pattern.test(message))) {
            console.warn("Ignoreret Matomo log-støj:", message);
            return;
        }

        const logService = this.injector.get(LogService);
        logService.logError(unwrapped);
        console.error(unwrapped);
    }
}
